import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=63c3fbef&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=63c3fbef&prod&scoped=true&lang=css&external"
import style1 from "./monitor.vue?vue&type=style&index=1&id=63c3fbef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3fbef",
  null
  
)

export default component.exports